import React from "react";
import { Link } from "../link";
import NewNavigationMegamenu from "./new-navigation-megamenu";
import classNames from "classnames";
import useClickOut from "../../hooks/use-click-out";
import ChevronRight from "../../icons/chevron-right-light.svg";
import { linKFromSlug } from "../../utility/paths";
import ArrowRight from "../../icons/arrow-right-long-sharp-light.svg";

const NewNavigationMenuItem = ({
  item,
  open,
  close,
  last,
  index,
  submenuOpen,
  itemClick,
  showAsButtonPage,
  bannerTop,
  bannerTopMenuHeight,
  closeMenu,
  children,
  labelManagerLabels,
  bannerMenu,
  defaultBanner,
}) => {
  const navigationRef = useClickOut(open, close, "new-menu");
  return (
    <li
      className={classNames(
        "new-navigation__item",
        {
          open,
        },
        item?.content?.id === showAsButtonPage?.[0]?.content?.id &&
          index === last &&
          "new-navigation__item-last"
      )}
    >
      <div
        className={classNames(
          "d-flex d-lg-inline-flex align-items-center new-navigation__button-wrapper",
          item?.content?.id === showAsButtonPage?.[0]?.content?.id &&
            index === last &&
            "new-navigation__button-wrapper-last"
        )}
      >
        {item.navigationMenuItems?.length ? (
          <>
            <button
              className="new-navigation__link first-level new-navigation__toggle d-lg-none"
              aria-label="Toggle button"
              onClick={itemClick}
              name={index}
            >
              {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
              <ChevronRight />
            </button>

            <button
              className={classNames(
                "new-navigation__link first-level new-navigation__toggle d-none d-lg-inline-flex",
                {
                  "new-navigation__toggle--open": open && submenuOpen,
                }
              )}
              aria-label="Toggle button"
              onClick={itemClick}
              name={index}
            >
              {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
            </button>
          </>
        ) : item.content?.slug ? (
          <Link
            className={`new-navigation__link first-level`}
            to={linKFromSlug(item.content.slug)}
            target={
              item?.content?.target && item?.content?.target?.length > 0
                ? item.content.target[0]
                : ""
            }
          >
            <span>
              {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
            </span>
            <ChevronRight className="d-lg-none" />
          </Link>
        ) : item?.content?.externalLink && item?.content?.externalLink ? (
          <a
            className="new-navigation__link first-level"
            href={item.content.externalLink}
            target={
              item?.content?.target && item?.content?.target?.length > 0
                ? item.content.target[0]
                : ""
            }
            rel={
              item.content.target && item.content.target[0] === "_blank"
                ? "noopener noreferrer"
                : ""
            }
          >
            <span>
              {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
            </span>
          </a>
        ) : (
          <span className="new-navigation__link first-level">
            {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
          </span>
        )}
        {item?.content?.id === showAsButtonPage?.[0]?.content?.id &&
          last === index &&
          showAsButtonPage &&
          showAsButtonPage?.[0]?.content?.showAsButtonText && (
            <div className="new-navigation__link-last d-lg-none">
              {showAsButtonPage?.[0].content.showAsButtonText}
            </div>
          )}
      </div>
      <div
        className={classNames("d-none new-navigation__submenu new-navigation__submenu--content", {
          "d-flex flex-column new-navigation__submenu--open": open && submenuOpen,
          "hasBannerTop": bannerTop && bannerTopMenuHeight !== 0,
        })}
        style={{
          "--banner-top-height":
            bannerTop && bannerTopMenuHeight ? `${bannerTopMenuHeight}px` : "0px",
        }}
      >
        <div className="new-header-top new-header-top--submenu-open d-lg-none">
          <div className="container-fluid wrapper">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/}
            <div
              className="d-flex align-items-center justify-content-between"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="new-navigation__subbutton new-navigation__subbutton--back d-flex align-items-center d-lg-none"
                onClick={() => closeMenu()}
              >
                <ArrowRight />
              </button>

              <button
                className=" d-flex justify-content-center new-navigation__submenu-title"
                onClick={() => closeMenu()}
              >
                {item.useCustomName && item.name ? item.name : item?.content?.liferayFields?.title}
              </button>

              <div className="d-flex justify-content-end d-lg-none new-header-top--submenu-open__close">
                {children}
              </div>
            </div>
          </div>
        </div>
        <NewNavigationMegamenu
          item={item}
          labelManagerLabels={labelManagerLabels}
          bannerMenu={bannerMenu}
          defaultBanner={defaultBanner}
          navigationRef={navigationRef}
          key={open}
        />
      </div>
    </li>
  );
};

export default NewNavigationMenuItem;
